import { render, staticRenderFns } from "./AppSelectOption.vue?vue&type=template&id=61a20d28&"
import script from "./AppSelectOption.vue?vue&type=script&lang=js&"
export * from "./AppSelectOption.vue?vue&type=script&lang=js&"
import style0 from "./AppSelectOption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports